import React from "react";

export const DiscountIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    width={90}
    height={90}
    fill="none"
    preserveAspectRatio="none"
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M39.107 7.405c3-3.795 8.755-3.8 11.761-.009l3.676 4.636a2.5 2.5 0 0 0 2.642.852l5.712-1.623c4.678-1.328 9.365 2.079 9.544 6.94l.212 5.749a2.5 2.5 0 0 0 1.653 2.26l5.453 1.958c4.619 1.658 6.427 7.233 3.66 11.287l-3.204 4.694a2.5 2.5 0 0 0 0 2.819l3.205 4.694c2.766 4.054.958 9.63-3.662 11.287l-5.452 1.957a2.5 2.5 0 0 0-1.653 2.261l-.212 5.75c-.18 4.86-4.865 8.267-9.544 6.939l-5.712-1.623a2.5 2.5 0 0 0-2.642.852l-3.676 4.636c-3.006 3.79-8.76 3.786-11.76-.009l-3.655-4.623a2.5 2.5 0 0 0-2.644-.854l-5.707 1.62c-4.678 1.33-9.365-2.078-9.544-6.938l-.212-5.75a2.5 2.5 0 0 0-1.653-2.26l-5.462-1.961c-4.615-1.657-6.425-7.223-3.668-11.277l3.2-4.704a2.5 2.5 0 0 0 0-2.812l-3.2-4.705c-2.757-4.054-.947-9.62 3.668-11.277l5.462-1.96a2.5 2.5 0 0 0 1.653-2.261l.212-5.75c.18-4.86 4.866-8.267 9.544-6.938l5.707 1.62a2.5 2.5 0 0 0 2.644-.854l3.654-4.623Zm7.843 3.097a2.5 2.5 0 0 0-3.92.003l-3.654 4.623a7.5 7.5 0 0 1-7.933 2.564l-5.707-1.62a2.5 2.5 0 0 0-3.181 2.312l-.212 5.75a7.5 7.5 0 0 1-4.961 6.783l-5.462 1.96a2.5 2.5 0 0 0-1.223 3.76l3.2 4.704a7.5 7.5 0 0 1 0 8.435l-3.2 4.705a2.5 2.5 0 0 0 1.223 3.759l5.462 1.96a7.5 7.5 0 0 1 4.961 6.783l.212 5.75a2.5 2.5 0 0 0 3.181 2.313l5.707-1.621a7.5 7.5 0 0 1 7.933 2.564l3.654 4.623a2.5 2.5 0 0 0 3.92.003l3.676-4.636a7.5 7.5 0 0 1 7.926-2.555l5.712 1.622a2.5 2.5 0 0 0 3.181-2.313l.212-5.75a7.5 7.5 0 0 1 4.961-6.783l5.452-1.957a2.5 2.5 0 0 0 1.22-3.762l-3.203-4.695a7.5 7.5 0 0 1 0-8.455l3.204-4.695a2.5 2.5 0 0 0-1.22-3.762l-5.453-1.957a7.5 7.5 0 0 1-4.96-6.783l-.213-5.75a2.5 2.5 0 0 0-3.181-2.313l-5.712 1.622a7.5 7.5 0 0 1-7.926-2.555l-3.676-4.636Z"
      clipRule="evenodd"
    />
    <path
      fill="#EE4D2D"
      fillRule="evenodd"
      d="m32.23 56.259 22.957-24.844 3.672 3.393-22.956 24.844-3.672-3.393Z"
      clipRule="evenodd"
    />
    <path
      fill="#EE4D2D"
      d="M41.11 35.042a6.082 6.082 0 1 1-12.163 0 6.082 6.082 0 0 1 12.163 0ZM62.929 54.782a6.082 6.082 0 1 1-12.164 0 6.082 6.082 0 0 1 12.164 0Z"
    />
  </svg>
);

export const CashbackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    width={90}
    height={90}
    fill="none"
  >
    <path
      fill="#EE4D2D"
      d="M44.724 44.34c-4.581-1.574-6.743-3.619-6.696-6.439.188-3.125 3.101-5.404 6.977-5.475 2.679.047 5.662.705 8.552 2.632a.749.749 0 0 0 .4.141c.14 0 .281-.094.398-.258.259-.423.94-1.457 1.152-1.833.14-.235.188-.564-.212-.846-.54-.4-2.09-1.222-2.913-1.575-2.232-.94-4.745-1.527-7.4-1.527h-.047c-5.662.023-10.102 3.595-10.477 8.389-.235 3.454 1.456 6.25 5.12 8.389.776.447 4.981 2.115 6.65 2.655 5.261 1.645 7.986 4.583 7.352 7.99-.587 3.102-3.852 5.1-8.34 5.17-3.57-.141-6.789-1.598-9.279-3.525a6.655 6.655 0 0 1-.423-.33.644.644 0 0 0-.423-.164c-.164 0-.305.07-.422.259-.142.235-1.105 1.621-1.363 1.974-.235.329-.118.493.14.705 1.035.87 2.42 1.81 3.36 2.303 2.584 1.315 5.404 2.044 8.387 2.161.235.024.47.024.728.024 1.786 0 3.83-.4 5.427-1.081 3.242-1.386 5.333-4.136 5.755-7.567.658-5.616-2.936-9.164-12.403-12.172Z"
    />
    <path
      fill="#EE4D2D"
      fillRule="evenodd"
      d="M44.93 28.16h.051c2.802 0 5.448.62 7.79 1.606l.005.002c.85.365 2.47 1.217 3.105 1.684.37.263.647.639.713 1.112.061.438-.081.805-.222 1.045-.141.249-.485.787-.772 1.236-.167.26-.315.492-.391.617l-.019.03-.02.03c-.208.29-.612.677-1.214.677-.368 0-.7-.139-.954-.309-2.696-1.798-5.478-2.417-7.996-2.464-3.524.071-5.82 2.094-5.978 4.514-.013 1.099.386 2.047 1.304 2.926.956.915 2.483 1.76 4.706 2.525 4.77 1.516 8.216 3.212 10.385 5.344 2.236 2.197 3.06 4.801 2.698 7.894l-.001.006c-.467 3.793-2.793 6.84-6.355 8.363-1.729.738-3.908 1.162-5.82 1.162h-.02c-.236 0-.502 0-.776-.025-3.114-.127-6.065-.89-8.773-2.27l-.01-.005c-1.012-.53-2.454-1.511-3.534-2.419l-.002-.002c-.124-.1-.447-.364-.573-.79-.16-.538.062-.987.259-1.263l.007-.01c.12-.164.419-.589.71-1.01a73.104 73.104 0 0 0 .582-.856l.014-.023.004-.006.001-.002.005-.008.005-.008a1.57 1.57 0 0 1 .538-.534c.246-.143.501-.195.733-.195.391 0 .755.14 1.063.397l.035.029.01.01.02.016a7.739 7.739 0 0 0 .228.176l.047.035-.002-.001.03.02.027.02c2.354 1.823 5.367 3.179 8.68 3.316 4.268-.075 6.888-1.949 7.344-4.354.252-1.353-.143-2.628-1.217-3.793-1.1-1.193-2.919-2.266-5.451-3.057l-.01-.003c-.867-.281-2.36-.843-3.72-1.386-1.33-.529-2.655-1.087-3.12-1.354l-.004-.003c-1.936-1.13-3.414-2.47-4.373-4.045-.966-1.586-1.373-3.356-1.242-5.276v-.01c.427-5.438 5.425-9.286 11.47-9.311Zm.007 2c-5.274.023-9.154 3.316-9.482 7.462-.103 1.533.218 2.886.955 4.095.743 1.22 1.942 2.347 3.67 3.356.314.18 1.477.678 2.858 1.228 1.35.538 2.79 1.08 3.593 1.34 2.727.853 4.9 2.07 6.319 3.608 1.444 1.566 2.096 3.463 1.713 5.517v.003c-.718 3.793-4.619 5.91-9.307 5.983h-.055c-3.81-.15-7.215-1.698-9.831-3.717a4.717 4.717 0 0 1-.113-.083c-.245.36-.584.848-.835 1.206.94.753 2.088 1.518 2.868 1.928 2.45 1.247 5.126 1.94 7.966 2.051l.03.001.03.003c.177.018.361.019.63.019 1.658 0 3.567-.375 5.034-1 2.92-1.25 4.776-3.7 5.155-6.767.294-2.522-.35-4.5-2.113-6.232-1.829-1.796-4.91-3.377-9.601-4.868l-.011-.003-.011-.004c-2.353-.809-4.193-1.772-5.45-2.976-1.29-1.236-1.95-2.713-1.92-4.425v-.022l.001-.022c.23-3.816 3.75-6.338 7.957-6.415h.036c2.727.048 5.774.697 8.742 2.575.075-.12.156-.245.237-.37.165-.258.331-.517.46-.725a22.709 22.709 0 0 0-2.471-1.298c-2.122-.894-4.503-1.448-7.009-1.448h-.045Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M27.843 74.825c16.127 9.73 37.134 4.501 46.914-11.707l4.28 2.583C67.842 84.258 43.768 90.273 25.26 79.106 16.697 73.94 10.83 65.997 8.11 57.123l-2.877.65c-1.535.346-2.844-1.137-2.314-2.622l3.457-9.684c.496-1.39 2.267-1.789 3.302-.745l7.215 7.277c1.107 1.116.548 3.02-.987 3.365l-2.902.655c2.42 7.6 7.492 14.372 14.84 18.806ZM77.4 33.022a33.872 33.872 0 0 0-14.157-16.865C47.117 6.427 26.11 11.655 16.33 27.864l-4.28-2.583C23.244 6.723 47.318.709 65.825 11.876a38.876 38.876 0 0 1 16.44 19.882l2.586-.671c1.523-.396 2.88 1.044 2.397 2.545l-3.144 9.788c-.451 1.404-2.209 1.86-3.276.85l-7.445-7.039c-1.141-1.08-.644-3 .88-3.395l3.135-.814Z"
      clipRule="evenodd"
    />
  </svg>
);

export const TransferIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    width={90}
    height={90}
    fill="none"
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M64.002 4.808A5.5 5.5 0 0 1 70 10.285V19h5a8.5 8.5 0 0 1 8.5 8.5v14h-5v-14A3.5 3.5 0 0 0 75 24H15v-5h50v-8.715a.5.5 0 0 0-.545-.498l-51.772 4.707A3.5 3.5 0 0 0 9.5 17.979V69.5A3.5 3.5 0 0 0 13 73h24v5H13a8.5 8.5 0 0 1-8.5-8.5V17.98a8.5 8.5 0 0 1 7.73-8.466l51.772-4.706Z"
      clipRule="evenodd"
    />
    <path
      fill="#EE4D2D"
      fillRule="evenodd"
      d="M82.313 51.307a2 2 0 0 1 0 3.385l-10.747 6.77c-1.332.838-3.066-.12-3.066-1.693V55.5H43v-5h25.5v-4.27c0-1.573 1.734-2.53 3.066-1.692l10.747 6.77ZM57.5 72.5v4.27c0 1.573-1.734 2.53-3.066 1.692l-10.747-6.77a2 2 0 0 1 0-3.384l10.747-6.77c1.332-.838 3.066.12 3.066 1.693V67.5H83v5H57.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export const VoucherIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    width={90}
    height={90}
    fill="none"
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M11 18.5A3.5 3.5 0 0 0 7.5 22v10.32c6.103.72 10.764 6.017 10.764 12.338 0 6.32-4.66 11.617-10.764 12.337v9.22a3.5 3.5 0 0 0 3.5 3.5h26.223v5H11a8.5 8.5 0 0 1-8.5-8.5V54.517a2.5 2.5 0 0 1 2.781-2.484c.26.03.526.045.796.045 3.914 0 7.187-3.266 7.187-7.42 0-4.155-3.273-7.42-7.187-7.42-.27 0-.535.014-.796.044A2.5 2.5 0 0 1 2.5 34.798V22a8.5 8.5 0 0 1 8.5-8.5h64.939a8.5 8.5 0 0 1 8.5 8.5v14.146h-5V22a3.5 3.5 0 0 0-3.5-3.5H11Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M27.107 33.446v-9.692h5v9.692h-5ZM27.107 48.954V39.26h5v9.693h-5ZM27.107 64.462v-9.693h5v9.693h-5Z"
      clipRule="evenodd"
    />
    <path
      fill="#EE4D2D"
      fillRule="evenodd"
      d="m61.536 38.974-3.58 6.148a8 8 0 0 1-5.22 3.792l-6.954 1.506 4.74 5.306a8 8 0 0 1 1.994 6.136l-.716 7.08 6.51-2.87a8 8 0 0 1 6.453 0l6.51 2.87-.716-7.08a8 8 0 0 1 1.993-6.136l4.741-5.306-6.954-1.506a8 8 0 0 1-5.22-3.792l-3.58-6.148Zm2.593-5.484c-1.157-1.987-4.028-1.987-5.185 0l-5.31 9.116a3 3 0 0 1-1.956 1.422l-10.31 2.232c-2.248.487-3.135 3.217-1.603 4.931l7.029 7.866a3 3 0 0 1 .748 2.301l-1.063 10.496c-.232 2.287 2.09 3.974 4.194 3.047l9.654-4.254a3 3 0 0 1 2.42 0l9.653 4.254c2.103.927 4.426-.76 4.194-3.047l-1.063-10.495a3 3 0 0 1 .748-2.302l7.029-7.866c1.532-1.714.645-4.444-1.603-4.93l-10.31-2.233a3 3 0 0 1-1.957-1.422l-5.31-9.116Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ScanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    width={90}
    height={90}
    fill="none"
  >
    <path
      fill="#EE4D2D"
      fillRule="evenodd"
      d="M83.5 46.5H7v-5h76.5v5Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M10 20c0-5.799 4.701-10.5 10.5-10.5h12v5h-12A5.5 5.5 0 0 0 15 20v12h-5V20ZM81 70c0 5.799-4.701 10.5-10.5 10.5h-12v-5h12A5.5 5.5 0 0 0 76 70V58h5v12ZM70.5 9.5C76.299 9.5 81 14.201 81 20v12h-5V20a5.5 5.5 0 0 0-5.5-5.5h-12v-5h12ZM20.5 80.5C14.701 80.5 10 75.799 10 70V58h5v12a5.5 5.5 0 0 0 5.5 5.5h12v5h-12Z"
      clipRule="evenodd"
    />
  </svg>
);

export const OnlinePaymentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    width={90}
    height={90}
    fill="none"
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M4.5 24a8.5 8.5 0 0 1 8.5-8.5h63.897a8.5 8.5 0 0 1 8.5 8.5v17.266h-5V24a3.5 3.5 0 0 0-3.5-3.5H13A3.5 3.5 0 0 0 9.5 24v7.235h59.038v5H9.5V66.36a3.5 3.5 0 0 0 3.5 3.5h26.82v5H13a8.5 8.5 0 0 1-8.5-8.5V24Z"
      clipRule="evenodd"
    />
    <path
      fill="#EE4D2D"
      fillRule="evenodd"
      d="M65.461 51.27c-3.532 0-7.065.825-10.619 2.512a25.657 25.657 0 0 0-8.982 7.048l-3.874-3.162a30.655 30.655 0 0 1 10.712-8.403c4.16-1.974 8.421-2.995 12.763-2.995 4.34 0 8.602 1.011 12.768 2.997a30.81 30.81 0 0 1 10.706 8.399l-3.87 3.167a25.812 25.812 0 0 0-8.988-7.053c-3.548-1.691-7.08-2.51-10.616-2.51Zm0 11.247c-1.953 0-3.99.456-6.13 1.432-2.1.957-3.795 2.249-5.142 3.878l-3.853-3.186c1.857-2.246 4.173-3.989 6.92-5.241 2.706-1.234 5.448-1.883 8.205-1.883 2.756 0 5.505.648 8.207 1.883 2.75 1.255 5.063 3.006 6.916 5.237l-3.847 3.194c-1.351-1.627-3.05-2.926-5.144-3.882h-.003c-2.13-.975-4.173-1.432-6.129-1.432Z"
      clipRule="evenodd"
    />
    <path
      fill="#EE4D2D"
      d="M71.615 74.462a6.154 6.154 0 1 1-12.307 0 6.154 6.154 0 0 1 12.307 0Z"
    />
  </svg>
);

export const YoutubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={36} height={37} fill="none">
    <path
      fill="#FF3D00"
      d="M35.192 27.354a4.483 4.483 0 0 1-3.77 3.591c-2.963.449-7.9.988-13.467.988a95.653 95.653 0 0 1-13.466-.988 4.483 4.483 0 0 1-3.77-3.59C.358 25.288 0 22.236 0 18.465c0-3.77.36-6.823.718-8.887a4.483 4.483 0 0 1 3.77-3.591C7.452 5.538 12.39 5 17.956 5c5.566 0 10.414.539 13.466.988a4.483 4.483 0 0 1 3.771 3.59c.36 2.065.808 5.118.808 8.888-.09 3.77-.449 6.823-.808 8.888Z"
    />
    <path fill="#fff" d="M14.364 24.75V12.183l10.773 6.284-10.773 6.285Z" />
  </svg>
);

export const BuyLoadIcon = () => (
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5454 16.5998C24.5454 11.7699 28.378 7.85449 33.1056 7.85449H76.8579C81.5856 7.85449 85.4181 11.7699 85.4181 16.5998V93.3638C85.4181 98.1937 81.5856 102.109 76.8579 102.109H33.1056C28.378 102.109 24.5454 98.1937 24.5454 93.3638V16.5998Z"
      fill="#EE4D2D"
    />
    <path
      d="M56.9456 95.2365C56.9456 96.8632 55.6269 98.1819 54.0001 98.1819C52.3734 98.1819 51.0547 96.8632 51.0547 95.2365C51.0547 93.6097 52.3734 92.291 54.0001 92.291C55.6269 92.291 56.9456 93.6097 56.9456 95.2365Z"
      fill="#FD9E8B"
    />
    <path
      d="M32.3999 18.468C32.3999 16.9442 33.5665 15.709 35.0055 15.709H74.9579C76.397 15.709 77.5635 16.9442 77.5635 18.468V85.6045C77.5635 87.1283 76.397 88.3635 74.9579 88.3635H35.0055C33.5665 88.3635 32.3999 87.1283 32.3999 85.6045V18.468Z"
      fill="#FF8066"
    />
    <rect
      x="57"
      y="19.6365"
      width="39.2727"
      height="39.2727"
      rx="8"
      fill="#FFC645"
    />
    <rect
      x="11.7817"
      y="49.0908"
      width="39.2727"
      height="39.2727"
      rx="8"
      fill="#FFC645"
    />
    <rect
      x="20.6182"
      y="58.9091"
      width="20.6182"
      height="20.6182"
      rx="2"
      fill="white"
    />
    <path
      d="M41.2363 65.7817H34.9884C33.0166 65.7817 31.4181 67.3203 31.4181 69.2181C31.4181 71.116 33.0166 72.6545 34.9884 72.6545H41.2363"
      stroke="#FFC645"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.8544 70.2C35.3966 70.2 35.8362 69.7604 35.8362 69.2181C35.8362 68.6759 35.3966 68.2363 34.8544 68.2363C34.3121 68.2363 33.8726 68.6759 33.8726 69.2181C33.8726 69.7604 34.3121 70.2 34.8544 70.2Z"
      fill="#FFC645"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.6364 27.491C68.7326 27.491 68 28.2236 68 29.1273V48.7637C68 49.6215 68.66 50.3251 69.4999 50.3945C69.5026 49.5535 70.112 48.8728 70.8635 48.8728C71.6166 48.8728 72.2271 49.5566 72.2271 50.4001H73.5909C73.5909 49.5566 74.2014 48.8728 74.9545 48.8728C75.7076 48.8728 76.3181 49.5566 76.3181 50.4001H77.682C77.682 49.5566 78.2925 48.8728 79.0456 48.8728C79.7987 48.8728 80.4092 49.5566 80.4092 50.4001H81.7728C81.7728 49.5566 82.3833 48.8728 83.1365 48.8728C83.8879 48.8728 84.4974 49.5535 84.5001 50.3945C85.34 50.3251 86 49.6215 86 48.7637V29.1273C86 28.2236 85.2674 27.491 84.3636 27.491H69.6364ZM76.3739 35.8L77.9913 36.1913C79.1652 36.5043 80 37.5478 80 38.7739C80 40.0783 79.0348 41.1739 77.7826 41.3826V41.7478C77.7826 42.1913 77.4435 42.5304 77 42.5304C76.5565 42.5304 76.2174 42.1913 76.2174 41.7478V41.4087C74.9652 41.2522 74 40.1826 74 38.8783C74 38.4348 74.3391 38.0957 74.7826 38.0957C75.2261 38.0957 75.5652 38.4348 75.5652 38.8783C75.5652 39.4261 76.0087 39.8696 76.5565 39.8696H77.3391C77.9391 39.8696 78.4348 39.3739 78.4348 38.7739C78.4348 38.2783 78.1217 37.8609 77.6261 37.7304L76.0087 37.3391C74.8348 37.0261 74 35.9826 74 34.7565C74 33.4522 74.9652 32.3565 76.2174 32.1478V31.7826C76.2174 31.3391 76.5565 31 77 31C77.4435 31 77.7826 31.3391 77.7826 31.7826V32.1217C79.0348 32.2783 80 33.3478 80 34.6522C80 35.0957 79.6609 35.4348 79.2174 35.4348C78.7739 35.4348 78.4348 35.0957 78.4348 34.6522C78.4348 34.1043 77.9913 33.6609 77.4435 33.6609H76.6609C76.0609 33.6609 75.5652 34.1565 75.5652 34.7565C75.5652 35.2522 75.8783 35.6696 76.3739 35.8Z"
      fill="white"
    />
  </svg>
);

export const PayOnlineIcon = () => (
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 25.0496H92V83.9999C92 88.4181 88.4183 91.9999 84 91.9999H24C19.5817 91.9999 16 88.4181 16 83.9999V25.0496Z"
      fill="#FFD16A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 16C19.5817 16 16 19.5817 16 24V25.0496V28.6667V83.9999C16 88.4182 19.5817 91.9999 24 91.9999H84C88.4183 91.9999 92 88.4181 92 83.9999V25.0496L92 24C92 19.5817 88.4183 16 84 16H24ZM21 30.0496H87V83.9999C87 85.6567 85.6569 86.9999 84 86.9999H24C22.3431 86.9999 21 85.6567 21 83.9999V30.0496Z"
      fill="#EE4D2D"
    />
    <path
      d="M22.3333 20.2223C21.7734 20.2223 21.2364 20.4447 20.8405 20.8406C20.4446 21.2365 20.2222 21.7735 20.2222 22.3334C20.2222 22.8933 20.4446 23.4303 20.8405 23.8262C21.2364 24.2221 21.7734 24.4445 22.3333 24.4445C22.8932 24.4445 23.4302 24.2221 23.8261 23.8262C24.222 23.4303 24.4444 22.8933 24.4444 22.3334C24.4444 21.7735 24.222 21.2365 23.8261 20.8406C23.4302 20.4447 22.8932 20.2223 22.3333 20.2223ZM30.7777 20.2223C30.2178 20.2223 29.6809 20.4447 29.2849 20.8406C28.889 21.2365 28.6666 21.7735 28.6666 22.3334C28.6666 22.8933 28.889 23.4303 29.2849 23.8262C29.6809 24.2221 30.2178 24.4445 30.7777 24.4445C31.3376 24.4445 31.8746 24.2221 32.2705 23.8262C32.6664 23.4303 32.8888 22.8933 32.8888 22.3334C32.8888 21.7735 32.6664 21.2365 32.2705 20.8406C31.8746 20.4447 31.3376 20.2223 30.7777 20.2223Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 41C34.4696 41 33.9609 41.2107 33.5858 41.5858C33.2107 41.9609 33 42.4696 33 43C33 43.5304 33.2107 44.0391 33.5858 44.4142C33.9609 44.7893 34.4696 45 35 45H38.6L42 55.2618V65C42 68.3 44.7 71 48 71H49C48.2043 71 47.4413 71.3161 46.8787 71.8787C46.3161 72.4413 46 73.2044 46 74C46 74.7956 46.3161 75.5587 46.8787 76.1213C47.4413 76.6839 48.2043 77 49 77C49.7957 77 50.5587 76.6839 51.1213 76.1213C51.6839 75.5587 52 74.7956 52 74C52 73.2044 51.6839 72.4413 51.1213 71.8787C50.5587 71.3161 49.7957 71 49 71H64C63.2043 71 62.4413 71.3161 61.8787 71.8787C61.3161 72.4413 61 73.2044 61 74C61 74.7956 61.3161 75.5587 61.8787 76.1213C62.4413 76.6839 63.2043 77 64 77C64.7956 77 65.5587 76.6839 66.1213 76.1213C66.6839 75.5587 67 74.7956 67 74C67 73.2044 66.6839 72.4413 66.1213 71.8787C65.5587 71.3161 64.7956 71 64 71H67V67H48C46.9 67 46 66.1 46 65V63H65C65.8 63 66.5 62.5 66.8 61.8L74.4 45H42.8L42.4 43.7C41.8 42.1 40.3 41 38.6 41H35Z"
      fill="white"
    />
    <path
      d="M64 73C63.7348 73 63.4804 73.1054 63.2929 73.2929C63.1054 73.4804 63 73.7348 63 74C63 74.2652 63.1054 74.5196 63.2929 74.7071C63.4804 74.8946 63.7348 75 64 75C64.2652 75 64.5196 74.8946 64.7071 74.7071C64.8946 74.5196 65 74.2652 65 74C65 73.7348 64.8946 73.4804 64.7071 73.2929C64.5196 73.1054 64.2652 73 64 73ZM49 73C48.7348 73 48.4804 73.1054 48.2929 73.2929C48.1054 73.4804 48 73.7348 48 74C48 74.2652 48.1054 74.5196 48.2929 74.7071C48.4804 74.8946 48.7348 75 49 75C49.2652 75 49.5196 74.8946 49.7071 74.7071C49.8946 74.5196 50 74.2652 50 74C50 73.7348 49.8946 73.4804 49.7071 73.2929C49.5196 73.1054 49.2652 73 49 73Z"
      fill="white"
    />
  </svg>
);

export const PayBillsIcon = () => (
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 83.35C12 75.2314 18.5814 68.65 26.7 68.65H81.3C89.4186 68.65 96 75.2314 96 83.35C96 91.4686 89.4186 98.05 81.3 98.05H26.7C18.5814 98.05 12 91.4686 12 83.35Z"
      fill="#FFC645"
    />
    <path
      d="M20.3999 15.186C20.3999 13.6993 21.9645 12.7323 23.2943 13.3972L27.9055 15.7028C28.4685 15.9843 29.1313 15.9843 29.6943 15.7028L36.3055 12.3972C36.8685 12.1157 37.5313 12.1157 38.0943 12.3972L44.7055 15.7028C45.2685 15.9843 45.9313 15.9843 46.4943 15.7028L53.1055 12.3972C53.6685 12.1157 54.3313 12.1157 54.8943 12.3972L61.5055 15.7028C62.0685 15.9843 62.7313 15.9843 63.2943 15.7028L69.9055 12.3972C70.4685 12.1157 71.1313 12.1157 71.6943 12.3972L78.3055 15.7028C78.8685 15.9843 79.5313 15.9843 80.0943 15.7028L84.7055 13.3972C86.0353 12.7323 87.5999 13.6993 87.5999 15.186V82.7C87.5999 87.1182 84.0182 90.7 79.5999 90.7H28.3999C23.9816 90.7 20.3999 87.1183 20.3999 82.7V15.186Z"
      fill="#FF8066"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.3999 21.5455V82.7C26.3999 83.8045 27.2953 84.7 28.3999 84.7H79.5999C80.7045 84.7 81.5999 83.8045 81.5999 82.7V21.5455C79.6367 22.163 77.492 22.0042 75.6222 21.0693L70.7999 18.6582L65.9776 21.0693C63.7254 22.1954 61.0744 22.1954 58.8222 21.0693L53.9999 18.6582L49.1776 21.0693C46.9254 22.1954 44.2744 22.1954 42.0222 21.0693L37.1999 18.6582L32.3776 21.0693C30.5078 22.0042 28.3631 22.163 26.3999 21.5455ZM23.2943 13.3972C21.9645 12.7323 20.3999 13.6993 20.3999 15.186V82.7C20.3999 87.1183 23.9816 90.7 28.3999 90.7H79.5999C84.0182 90.7 87.5999 87.1182 87.5999 82.7V15.186C87.5999 13.6993 86.0353 12.7323 84.7055 13.3972L80.0943 15.7028C79.5313 15.9843 78.8685 15.9843 78.3055 15.7028L71.6943 12.3972C71.1313 12.1157 70.4685 12.1157 69.9055 12.3972L63.2943 15.7028C62.7313 15.9843 62.0685 15.9843 61.5055 15.7028L54.8943 12.3972C54.3313 12.1157 53.6685 12.1157 53.1055 12.3972L46.4943 15.7028C45.9313 15.9843 45.2685 15.9843 44.7055 15.7028L38.0943 12.3972C37.5313 12.1157 36.8685 12.1157 36.3055 12.3972L29.6943 15.7028C29.1313 15.9843 28.4685 15.9843 27.9055 15.7028L23.2943 13.3972Z"
      fill="#EE4D2D"
    />
    <path
      d="M54.3538 30L46.6 44.1818H53.2462V54L61 39.8182H54.3538V30Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.6 66.25H37V61H70.6V66.25Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.6 78.5H37V73.25H70.6V78.5Z"
      fill="white"
    />
  </svg>
);

export const QRIcon = () => (
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7456 22.8801C13.7456 18.3774 17.3957 14.7273 21.8984 14.7273H86.1019C90.6046 14.7273 94.2547 18.3774 94.2547 22.8801V87.0836C94.2547 91.5863 90.6046 95.2364 86.1019 95.2364H21.8984C17.3957 95.2364 13.7456 91.5863 13.7456 87.0836V22.8801Z"
      fill="#EE4D2D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.1967 27.1874V41.6599H40.6691V27.1874H26.1967ZM24.9907 22.3633C22.9924 22.3633 21.3726 23.9832 21.3726 25.9814V42.8659C21.3726 44.8641 22.9924 46.484 24.9907 46.484H41.8752C43.8734 46.484 45.4933 44.8641 45.4933 42.8659V25.9814C45.4933 23.9832 43.8734 22.3633 41.8752 22.3633H24.9907Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.1967 67.8565V82.3289H40.6691V67.8565H26.1967ZM24.9907 63.0323C22.9924 63.0323 21.3726 64.6522 21.3726 66.6505V83.535C21.3726 85.5332 22.9924 87.1531 24.9907 87.1531H41.8752C43.8734 87.1531 45.4933 85.5332 45.4933 83.535V66.6505C45.4933 64.6522 43.8734 63.0323 41.8752 63.0323H24.9907Z"
      fill="#FFC645"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.8754 27.1874V41.6599H81.3478V27.1874H66.8754ZM65.6694 22.3633C63.6712 22.3633 62.0513 23.9832 62.0513 25.9814V42.8659C62.0513 44.8641 63.6712 46.484 65.6694 46.484H82.5539C84.5521 46.484 86.172 44.8641 86.172 42.8659V25.9814C86.172 23.9832 84.5521 22.3633 82.5539 22.3633H65.6694Z"
      fill="#FFC645"
    />
    <path
      d="M71.0962 34.4229C71.0962 32.7577 72.4461 31.4078 74.1113 31.4078C75.7765 31.4078 77.1264 32.7577 77.1264 34.4229C77.1264 36.0881 75.7765 37.438 74.1113 37.438C72.4461 37.438 71.0962 36.0881 71.0962 34.4229Z"
      fill="white"
    />
    <path
      d="M30.418 34.4229C30.418 32.7577 31.7679 31.4078 33.4331 31.4078C35.0982 31.4078 36.4481 32.7577 36.4481 34.4229C36.4481 36.0881 35.0982 37.438 33.4331 37.438C31.7679 37.438 30.418 36.0881 30.418 34.4229Z"
      fill="white"
    />
    <path
      d="M30.8535 75.5918C30.8535 73.9244 32.2052 72.5728 33.8726 72.5728C35.54 72.5728 36.8917 73.9244 36.8917 75.5918C36.8917 77.2592 35.54 78.6109 33.8726 78.6109C32.2052 78.6109 30.8535 77.2592 30.8535 75.5918Z"
      fill="white"
    />
    <path
      d="M21.3726 54.9257C21.3726 53.2605 22.7225 51.9106 24.3876 51.9106C26.0528 51.9106 27.4027 53.2605 27.4027 54.9257C27.4027 56.5909 26.0528 57.9408 24.3876 57.9408C22.7225 57.9408 21.3726 56.5909 21.3726 54.9257Z"
      fill="white"
    />
    <path
      d="M80.1655 54.9782C80.1655 53.313 81.5154 51.9631 83.1806 51.9631C84.8458 51.9631 86.1957 53.313 86.1957 54.9782C86.1957 56.6434 84.8458 57.9933 83.1806 57.9933C81.5154 57.9933 80.1655 56.6434 80.1655 54.9782Z"
      fill="white"
    />
    <path
      d="M50.981 84.1626C50.981 82.4974 52.3309 81.1475 53.996 81.1475C55.6612 81.1475 57.0111 82.4974 57.0111 84.1626C57.0111 85.8277 55.6612 87.1776 53.996 87.1776C52.3309 87.1776 50.981 85.8277 50.981 84.1626Z"
      fill="white"
    />
    <path
      d="M50.9204 43.4693C50.9204 41.8041 52.2703 40.4542 53.9355 40.4542C55.6007 40.4542 56.9506 41.8041 56.9506 43.4693C56.9506 45.1345 55.6007 46.4844 53.9355 46.4844C52.2703 46.4844 50.9204 45.1345 50.9204 43.4693Z"
      fill="white"
    />
    <path
      d="M50.9204 54.9257C50.9204 53.2605 52.2703 51.9106 53.9355 51.9106C55.6007 51.9106 56.9506 53.2605 56.9506 54.9257C56.9506 56.5909 55.6007 57.9408 53.9355 57.9408C52.2703 57.9408 50.9204 56.5909 50.9204 54.9257Z"
      fill="white"
    />
    <path
      d="M32.2271 54.3227C32.2271 52.9906 33.307 51.9106 34.6391 51.9106H43.0814C44.4135 51.9106 45.4934 52.9906 45.4934 54.3227V55.5288C45.4934 56.8609 44.4135 57.9408 43.0814 57.9408H34.6391C33.307 57.9408 32.2271 56.8609 32.2271 55.5288V54.3227Z"
      fill="white"
    />
    <path
      d="M50.981 65.4444C50.981 64.1123 52.0609 63.0323 53.393 63.0323H61.8353C63.1674 63.0323 64.2474 64.1123 64.2474 65.4444V66.6505C64.2474 67.9826 63.1674 69.0625 61.8353 69.0625H53.393C52.0609 69.0625 50.981 67.9826 50.981 66.6505V65.4444Z"
      fill="white"
    />
    <path
      d="M73.1211 65.4444C73.1211 64.1123 74.201 63.0323 75.5332 63.0323H83.9754C85.3076 63.0323 86.3875 64.1123 86.3875 65.4444V66.6505C86.3875 67.9826 85.3076 69.0625 83.9754 69.0625H75.5332C74.201 69.0625 73.1211 67.9826 73.1211 66.6505V65.4444Z"
      fill="white"
    />
    <path
      d="M73.1211 76.5146C73.1211 75.1825 74.201 74.1025 75.5332 74.1025H83.9754C85.3076 74.1025 86.3875 75.1825 86.3875 76.5146V84.9569C86.3875 86.289 85.3076 87.3689 83.9754 87.3689H75.5332C74.201 87.3689 73.1211 86.289 73.1211 84.9569V76.5146Z"
      fill="white"
    />
    <path
      d="M54.5391 22.3633C55.8713 22.3633 56.9512 23.4432 56.9512 24.7754L56.9512 33.2176C56.9512 34.5498 55.8712 35.6297 54.5391 35.6297L53.3331 35.6297C52.0009 35.6297 50.921 34.5498 50.921 33.2176L50.921 24.7754C50.921 23.4432 52.0009 22.3633 53.3331 22.3633L54.5391 22.3633Z"
      fill="white"
    />
  </svg>
);

export const MillionUserIcon = () => (
  <svg
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9997 31.7045C48.9536 31.7045 52.1588 28.4993 52.1588 24.5454C52.1588 20.5916 48.9536 17.3863 44.9997 17.3863C41.0459 17.3863 37.8406 20.5916 37.8406 24.5454C37.8406 28.4993 41.0459 31.7045 44.9997 31.7045ZM44.9997 36.8182C51.7778 36.8182 57.2725 31.3235 57.2725 24.5454C57.2725 17.7674 51.7778 12.2727 44.9997 12.2727C38.2217 12.2727 32.727 17.7674 32.727 24.5454C32.727 31.3235 38.2217 36.8182 44.9997 36.8182Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.1475 56.25C29.1475 47.495 36.2448 40.3977 44.9997 40.3977C53.7547 40.3977 60.852 47.495 60.852 56.25V78.75C60.852 80.1621 59.7073 81.3068 58.2952 81.3068C56.8831 81.3068 55.7384 80.1621 55.7384 78.75V56.25C55.7384 50.3192 50.9305 45.5113 44.9997 45.5113C39.0689 45.5113 34.2611 50.3192 34.2611 56.25V78.75C34.2611 80.1621 33.1164 81.3068 31.7043 81.3068C30.2922 81.3068 29.1475 80.1621 29.1475 78.75V56.25Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.636 43.9772C77.5899 43.9772 80.7951 40.772 80.7951 36.8181C80.7951 32.8643 77.5899 29.659 73.636 29.659C69.6822 29.659 66.4769 32.8643 66.4769 36.8181C66.4769 40.772 69.6822 43.9772 73.636 43.9772ZM73.636 49.0909C80.414 49.0909 85.9087 43.5962 85.9087 36.8181C85.9087 30.0401 80.414 24.5454 73.636 24.5454C66.858 24.5454 61.3633 30.0401 61.3633 36.8181C61.3633 43.5962 66.858 49.0909 73.636 49.0909Z"
      fill="#EE4D2D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.0792 56.25C71.0792 54.8379 72.2239 53.6931 73.636 53.6931C80.6965 53.6931 86.4201 59.4168 86.4201 66.4772V78.75C86.4201 80.162 85.2754 81.3068 83.8633 81.3068C82.4512 81.3068 81.3065 80.162 81.3065 78.75V66.4772C81.3065 62.241 77.8723 58.8068 73.636 58.8068C72.2239 58.8068 71.0792 57.662 71.0792 56.25Z"
      fill="#EE4D2D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3632 43.9772C20.317 43.9772 23.5223 40.772 23.5223 36.8181C23.5223 32.8643 20.317 29.659 16.3632 29.659C12.4093 29.659 9.2041 32.8643 9.2041 36.8181C9.2041 40.772 12.4093 43.9772 16.3632 43.9772ZM16.3632 49.0909C23.1412 49.0909 28.6359 43.5962 28.6359 36.8181C28.6359 30.0401 23.1412 24.5454 16.3632 24.5454C9.58515 24.5454 4.09047 30.0401 4.09047 36.8181C4.09047 43.5962 9.58515 49.0909 16.3632 49.0909Z"
      fill="#EE4D2D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.92 56.25C18.92 54.8379 17.7753 53.6931 16.3632 53.6931C9.30273 53.6931 3.5791 59.4168 3.5791 66.4772V78.75C3.5791 80.162 4.72383 81.3068 6.13592 81.3068C7.54801 81.3068 8.69274 80.162 8.69274 78.75V66.4772C8.69274 62.241 12.1269 58.8068 16.3632 58.8068C17.7753 58.8068 18.92 57.662 18.92 56.25Z"
      fill="#EE4D2D"
    />
  </svg>
);

export const CoinCheckMarkIcon = () => (
  <svg
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9998 13.3675C27.5297 13.3675 13.3673 27.5299 13.3673 45.0001C13.3673 62.4702 27.5297 76.6326 44.9998 76.6326C47.8933 76.6326 50.6921 76.2448 53.3489 75.5198L54.7141 80.5225C51.6164 81.3678 48.3587 81.8183 44.9998 81.8183C24.6657 81.8183 8.18164 65.3342 8.18164 45.0001C8.18164 24.6659 24.6657 8.18188 44.9998 8.18188C65.3339 8.18188 81.818 24.6659 81.818 45.0001C81.818 49.1083 81.1441 53.0645 79.8989 56.7609L74.9846 55.1054C76.0525 51.9355 76.6323 48.5382 76.6323 45.0001C76.6323 27.5299 62.47 13.3675 44.9998 13.3675Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M79.6879 63.5711L67.8324 76.5711C67.3784 77.0688 66.7428 77.3623 66.0696 77.3851C65.3963 77.4078 64.7423 77.1579 64.2558 76.6919L57.1113 69.8482L60.57 66.2374L65.8644 71.3089L75.9935 60.2019L79.6879 63.5711Z"
      fill="#EE4D2D"
    />
    <path
      d="M46.0227 24.5454C47.2779 24.5454 48.2955 25.5629 48.2955 26.8181V28.4808C49.6111 28.7278 50.8647 29.1172 52.0327 29.6092L52.0379 29.6114C52.7942 29.9356 54.2338 30.6931 54.7982 31.1077C55.1262 31.342 55.3726 31.6757 55.4314 32.0963C55.486 32.4859 55.3595 32.8123 55.2343 33.0251C55.1088 33.2464 54.8028 33.725 54.548 34.1237C54.3994 34.356 54.2683 34.5612 54.2003 34.6725L54.1837 34.6997L54.1651 34.7256C53.9812 34.9832 53.6222 35.3277 53.0868 35.3277C52.7598 35.3277 52.4651 35.2041 52.2386 35.053C49.8421 33.4549 47.3695 32.9048 45.1312 32.8631C41.9988 32.9259 39.9581 34.7237 39.8173 36.8751C39.8058 37.8516 40.161 38.6945 40.9767 39.4757C41.8261 40.2894 43.1835 41.0402 45.1593 41.7202C49.3994 43.0681 52.4626 44.5756 54.3911 46.4706C56.3784 48.4235 57.1106 50.7386 56.7887 53.4874L56.788 53.4927C56.3725 56.8641 54.305 59.5733 51.1393 60.9271C50.2794 61.2939 49.2942 61.5735 48.2955 61.7486V63.1818C48.2955 64.437 47.2779 65.4545 46.0227 65.4545C44.7675 65.4545 43.75 64.437 43.75 63.1818V61.818C41.5354 61.5571 39.4258 60.9211 37.4604 59.9202L37.4505 59.9151C36.5519 59.4432 35.2699 58.5719 34.3102 57.7653L34.3078 57.7634C34.1979 57.6736 33.9112 57.4393 33.7985 57.0602C33.6568 56.5832 33.8537 56.1834 34.029 55.9379L34.0354 55.9289C34.1422 55.7833 34.4073 55.4062 34.6662 55.0322C34.7944 54.8469 34.9186 54.6661 35.0178 54.5196C35.0675 54.4463 35.11 54.3829 35.1431 54.3327C35.1597 54.3075 35.1733 54.2868 35.1838 54.2704L35.1963 54.2507L35.1999 54.2449L35.2009 54.2433L35.2054 54.2357L35.2097 54.2289C35.3202 54.052 35.4742 53.8793 35.6878 53.7546C35.9059 53.6274 36.1331 53.5813 36.3394 53.5813C36.6869 53.5813 37.0106 53.7053 37.2844 53.9336L37.3154 53.9594L37.3248 53.9688L37.3416 53.9825C37.3675 54.0035 37.4022 54.0308 37.4396 54.0598C37.4768 54.0886 37.5139 54.1168 37.5442 54.1395C37.5651 54.1551 37.5776 54.1642 37.583 54.1681L37.586 54.1703C37.586 54.1703 37.5862 54.1705 37.5844 54.1693L37.6104 54.1866L37.6351 54.2058C39.7278 55.8251 42.4063 57.0305 45.3501 57.1528C49.1446 57.0862 51.4733 55.4206 51.879 53.2827C52.1026 52.0797 51.7519 50.9465 50.7967 49.9109C49.8187 48.8505 48.2023 47.8968 45.9514 47.1932L45.9426 47.1905C45.1722 46.9408 43.8448 46.441 42.6353 45.9591C41.4544 45.4887 40.2764 44.9927 39.8634 44.7548L39.859 44.7523C38.1387 43.7485 36.8246 42.5573 35.9718 41.1571C35.1131 39.7472 34.7518 38.1735 34.8679 36.4673L34.8685 36.4581C35.2161 32.0245 38.9824 28.7803 43.75 28.2561V26.8181C43.75 25.5629 44.7675 24.5454 46.0227 24.5454Z"
      fill="#EE4D2D"
    />
  </svg>
);

export const FreeFeeIcon = () => (
  <svg
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9999 10.6827L40.6484 14.2226C38.6137 15.8778 35.9695 16.5863 33.3797 16.1702L27.8413 15.2804L25.8428 20.5217C24.9082 22.9725 22.9725 24.9082 20.5217 25.8428L15.2804 27.8413L16.1702 33.3797C16.5863 35.9694 15.8778 38.6137 14.2226 40.6484L10.6827 44.9999L14.2226 49.3513C15.8778 51.3861 16.5863 54.0303 16.1702 56.6201L15.2804 62.1585L20.5217 64.157C22.9725 65.0915 24.9082 67.0273 25.8428 69.4781L27.8413 74.7194L33.3797 73.8296C35.9695 73.4135 38.6137 74.122 40.6484 75.7772L44.9999 79.317L49.3513 75.7772C51.3861 74.122 54.0303 73.4135 56.6201 73.8296L62.1585 74.7194L64.157 69.4781C65.0915 67.0273 67.0272 65.0915 69.4781 64.157L74.7194 62.1585L73.8296 56.6201C73.4135 54.0303 74.122 51.3861 75.7772 49.3513L79.317 44.9999L75.7772 40.6484C74.122 38.6137 73.4135 35.9695 73.8296 33.3797L74.7194 27.8413L69.4781 25.8428C67.0273 24.9082 65.0915 22.9725 64.157 20.5217L62.1585 15.2804L56.6201 16.1702C54.0303 16.5863 51.3861 15.8778 49.3513 14.2226L44.9999 10.6827ZM28.1377 75.4968L28.137 75.495L28.1377 75.4968ZM14.503 28.1377L14.5048 28.137L14.503 28.1377ZM47.5815 6.19086C46.0778 4.96763 43.922 4.96763 42.4183 6.19086L37.4215 10.2557C36.5171 10.9914 35.3419 11.3063 34.1909 11.1213L27.8311 10.0995C25.9172 9.792 24.0503 10.8699 23.3597 12.6811L21.0647 18.6998C20.6493 19.789 19.789 20.6493 18.6998 21.0647L12.6811 23.3597C10.8699 24.0503 9.792 25.9172 10.0995 27.8311L11.1213 34.1909C11.3063 35.3419 10.9914 36.5171 10.2557 37.4215L6.19086 42.4183C4.96763 43.922 4.96763 46.0778 6.19086 47.5815L10.2557 52.5783C10.9914 53.4826 11.3063 54.6579 11.1213 55.8089L10.0995 62.1687C9.792 64.0826 10.8699 65.9495 12.6811 66.6401L18.6998 68.9351C19.789 69.3504 20.6493 70.2107 21.0647 71.3L23.3597 77.3187C24.0503 79.1299 25.9172 80.2078 27.8311 79.9003L34.1909 78.8784C35.3419 78.6935 36.5171 79.0084 37.4215 79.7441L42.4183 83.8089C43.922 85.0322 46.0778 85.0322 47.5815 83.8089L52.5783 79.7441C53.4826 79.0084 54.6579 78.6935 55.8089 78.8784L62.1687 79.9003C64.0825 80.2078 65.9495 79.1299 66.6401 77.3187L68.9351 71.3C69.3504 70.2108 70.2107 69.3504 71.3 68.9351L77.3187 66.6401C79.1299 65.9495 80.2078 64.0826 79.9003 62.1687L78.8784 55.8089C78.6935 54.6579 79.0084 53.4826 79.7441 52.5783L83.8089 47.5815C85.0322 46.0778 85.0322 43.922 83.8089 42.4183L79.7441 37.4215C79.0084 36.5171 78.6935 35.3419 78.8784 34.1909L79.9003 27.8311C80.2078 25.9172 79.1299 24.0503 77.3187 23.3597L71.3 21.0647C70.2108 20.6493 69.3504 19.789 68.9351 18.6998L66.6401 12.6811C65.9495 10.8699 64.0826 9.792 62.1687 10.0995L55.8089 11.1213C54.6579 11.3063 53.4826 10.9914 52.5783 10.2557L47.5815 6.19086Z"
      fill="black"
    />
    <path
      d="M21.4775 37.8408H31.1618V40.9871H24.7131V44.4574H31.028V47.6037H24.7131V52.1218H21.4775V37.8408Z"
      fill="#EE4D2D"
    />
    <path
      d="M33.6193 52.1218V37.8408H37.7697C38.0672 37.8408 38.3722 37.8408 38.6846 37.8408C38.997 37.8408 39.3094 37.8483 39.6218 37.8631C40.3507 37.8929 41.0276 38.0268 41.6524 38.2648C42.2772 38.4879 42.8127 38.8226 43.259 39.2689C43.7201 39.7003 44.0772 40.2359 44.33 40.8755C44.5978 41.5152 44.7317 42.259 44.7317 43.1069C44.7317 44.3119 44.4788 45.3012 43.973 46.0747C43.4821 46.8483 42.8201 47.4284 41.9871 47.8152L45.0887 52.1218H41.4069L38.7292 48.3507H37.7697H36.8102V52.1218H33.6193ZM36.8102 45.2268H37.5689C37.7028 45.2268 37.859 45.2268 38.0375 45.2268C38.216 45.2268 38.3945 45.2268 38.573 45.2268C38.7664 45.2268 38.9449 45.2268 39.1086 45.2268C39.2722 45.2119 39.4061 45.2045 39.5102 45.2045C40.1053 45.1747 40.6036 45.0036 41.0053 44.6912C41.4069 44.364 41.6077 43.8359 41.6077 43.1069C41.6077 42.3929 41.4069 41.8722 41.0053 41.545C40.6036 41.2028 40.1053 41.0169 39.5102 40.9871C39.3019 40.9722 38.9896 40.9648 38.573 40.9648C38.1714 40.9499 37.8441 40.9425 37.5912 40.9425H36.8102V45.2268Z"
      fill="#EE4D2D"
    />
    <path
      d="M46.8069 37.8408H56.7143V40.9425H50.0201V43.6094L56.5805 43.6318V46.5995H50.0648V49.1094H56.7143V52.1218H46.8069V37.8408Z"
      fill="#EE4D2D"
    />
    <path
      d="M59.2247 37.8408H69.1321V40.9425H62.4379V43.6094L68.9982 43.6318V46.5995H62.4825V49.1094H69.1321V52.1218H59.2247V37.8408Z"
      fill="#EE4D2D"
    />
  </svg>
);

export const FastTransferIcon = () => (
  <svg
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 18C8.5 13.3056 12.3056 9.5 17 9.5H78C82.6944 9.5 86.5 13.3056 86.5 18L83.5 42.6842H78.5L81.5 18C81.5 16.067 79.933 14.5 78 14.5H17C15.067 14.5 13.5 16.067 13.5 18L12.5 24.8421H67V29.8421H12.5L9.5 59C9.5 60.933 11.067 62.5 13 62.5H48V67.5H13C8.30558 67.5 4.5 63.6944 4.5 59L8.5 18Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83 54.5H56V49.5H83V54.5Z"
      fill="#EE4D2D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75 67.5H48V62.5H75V67.5Z"
      fill="#EE4D2D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61 80.5H36V75.5H61V80.5Z"
      fill="#EE4D2D"
    />
  </svg>
);

export const TiktokIcon = () => (
  <svg
    fill="#000000"
    width={36}
    height={36}
    viewBox="0 0 512 512"
    id="icons"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z" />
  </svg>
);
